export default "__VITE_ASSET__CUd3X0tQ__"